<script>
	export let name;
</script>


<header class=" fixed w-full z-50">
	<div class="bg-white shadow-sm py-3 px-4">
		<a href="/">
			<img src="/img/6Storage_Logo.svg" alt="6Storage-Logo" class="w-auto h-10 ">
		</a>
	</div>
	<nav class="flex content-between fixed bottom-0 w-full py-4 px-3 z-0" style="background-color: #4083A1;">
        <div class=" grid grid-cols-5 w-full justify-center">
            <div class="">
				<!-- svelte-ignore a11y-invalid-attribute -->
                <a href="#">
                    <img src=" /img/Home-Icon.svg" alt="Home" class="bg-white rounded-md  p-2">
                </a>             
            </div>
            <div>
				<!-- svelte-ignore a11y-invalid-attribute -->
                <a href="#">
                    <img src=" /img/Group 3470.svg" alt="Home" class="rounded-md  p-2">
                </a>             
            </div>
            <div>
				<!-- svelte-ignore a11y-invalid-attribute -->
                <a href="#">
                    <img src=" /img/System-icon.svg" alt="System-Icon" class="rounded-md  p-2">
                </a>             
            </div>
            <div>
                <!-- svelte-ignore a11y-invalid-attribute -->
                <a href="#">
                    <img src=" /img/Hand-Setting-icon.svg" alt="Hand-Setting-icon" class="rounded-md  p-2">
                </a>             
            </div>
            <div>
                <!-- svelte-ignore a11y-invalid-attribute -->
                <a href="#">
                    <img src=" /img/Hand-holder-icon.svg" alt="Hand-Holder-icon" class="rounded-md  p-2">
                </a>             
            </div>
        </div>
    </nav>
</header>

<main class=" bg-cover pb-40 fixed w-full h-full overflow-auto" style="background-image: url('/img/Background Pic.svg');">
	<!-- Left side nav bar tap -->
	<nav class=" z-10 shadow-sm gap-7 absolute top-14 pb-8 pt-44 pl-3 -mt-8 w-28 bg-no-repeat" style="background-image: url('/img/Group 4144.png');">
        <div class="grid gap-8" style="font-size: 10px;">
            <div class="w-12">
                <img src="/img/Review.svg" alt="Review" class="w-10">
				<small class=" text-gray-600  text-center py-1">Review</small>
            </div>
            <div class="w-12">
                <img src="/img/Integration.svg" alt="Integration" class=" w-10">
				<p class=" text-gray-600  text-center py-1">Integration</p>
            </div>
            <div class="w-12">
                <img src="/img/Software's.svg" alt="Software" class=" w-10">
				<p class=" text-gray-600  text-center py-1">Software</p>
            </div>
            <div class="w-12">
                <img src="/img/Testimonial.svg" alt="Testimonial" class=" w-10">
				<p class=" text-gray-600  text-center py-1">Testimonials</p>
            </div>
            <div class="w-12">
                <img src="/img/FAQ.svg" alt="FAQ" class=" w-10">
				<p class=" text-gray-600  text-center py-1">FAQ</p>
            </div>
        </div>
    </nav>
	
	
	


	<!-- grid structure is here... -->
	<!-- Product Services here -->
	<div class=" px-3 py-3 pt-24">
		<div class="grid grid-cols-1 pl-8">
			<div class=" text-left pl-20 font-semibold bg-white bg-opacity-25 border-white border 
			border-opacity-20 rounded-xl backdrop-blur-xl py-3 px-6 shadow-md brightness-150"
			style="box-shadow: 0 8px 32px 0 rgba( 31, 38, 135, 0.37 );
			backdrop-filter: blur( 20px );
			-webkit-backdrop-filter: blur( 20px ); ">
				<h2 class=" text-2xl text-green-700">
					Product and Services
				</h2>
			</div>
		</div>
	</div>
	<div class=" px-3">
		<div class=" grid grid-cols-2 pl-16">
			
			<div class=" py-4 px-3 bg-gradient-to-bl from-purple-500 to-purple-300 m-1 rounded-xl">
				<div class=" flex justify-end pb-2">
					<img src=" /img/Software-pic.svg" alt="Software" class=" w-3/4 h-24">
				</div>
				<div class=" text-left text-white ">
					<h2 class=" text-xl pb-3 font-bold">
						Software
					</h2>
					<p class=" text-base font-medium">
						Self storage management software
					</p>
				</div>
			</div>	
			<div class=" py-4 px-3 bg-gradient-to-bl from-purple-900 to-purple-500 m-1 rounded-xl">
				<div class=" flex justify-end pb-2">
					<img src=" /img/Gate Access pic.svg" alt="Gate Access" class=" w-3/4 h-24">
				</div>
				<div class=" text-left text-white ">
					<h2 class=" text-xl pb-3 font-bold">
						Gate Access
					</h2>
					<p class=" text-base font-medium">
						Cloud based access control system
					</p>
				</div>
			</div>	
			<div class=" py-4 px-3 bg-gradient-to-tr from-green-500 to-green-300 m-1 rounded-xl">
				<div class=" flex justify-end pb-2">
					<img src=" /img/Calculator Pic.svg" alt="Calculator" class=" w-3/4 h-24">
				</div>
				<div class=" text-left text-white ">
					<h2 class=" text-xl pb-3 font-bold">
						Calculator
					</h2>
					<p class=" text-base font-medium">
						Storage calculator for Self Storage Units
					</p>
				</div>
			</div>	
			<div class=" py-4 px-3 bg-gradient-to-b from-pink-300 to-pink-200 m-1 rounded-xl">
				<div class=" flex justify-end pb-2">
					<img src=" /img/Website Pic.svg" alt="Website" class=" w-3/4 h-24">
				</div>
				<div class=" text-left text-white ">
					<h2 class=" text-xl pb-3 font-bold">
						Website
					</h2>
					<p class=" text-base font-medium">
						Managed Website for Self Storage Owners
					</p>
				</div>
			</div>	
			<div class=" col-span-2 py-4 px-3 bg-gradient-to-tr from-yellow-400 to-yellow-200 m-1 rounded-xl">
				<div class=" grid grid-cols-3">					
					<div class=" col-span-2 text-left text-white pt-8">
						<h2 class=" text-xl pb-3 font-bold">
							Marketing
						</h2>
						<p class=" text-base font-medium">
							Digital Marketing Services for Self Storage Owners
						</p>
					</div>
					<div class="pb-2">
						<img src=" /img/Marketing Pic.svg" alt="Marketing" class=" w-full">
					</div>
				</div>
				
				
			</div>
					
		</div>
	</div>

	<!-- Review of Self Storage Software by our Clients section is here... -->
	<div class=" px-3 py-2 my-2">
		<div class="grid grid-cols-1 pl-8">			
			<div class=" text-left pl-10 font-semibold bg-white bg-opacity-25 border-white border 
			border-opacity-20 rounded-xl backdrop-blur-xl py-3 px-6 shadow-md brightness-150"
			style="box-shadow: 0 8px 32px 0 rgba( 31, 38, 135, 0.37 );
			backdrop-filter: blur( 20px );
			-webkit-backdrop-filter: blur( 20px ); ">
				<h2 class=" text-2xl text-green-700">
					Review of Self Storage Software by our Clients
				</h2>
			</div>
		</div>
	</div>

	<div class=" mx-3 px-3 bg-white rounded-lg py-5 ml-20">
		<div class=" grid grid-cols-3 gap-2">
			<div>
				<img src="/img/Reviews-capterra@2x.png" alt="Reviews-capterra" class=" w-3/4 h-14">
			</div>
			<div>
				<img src=" /img/Reviews_getapp copy 2@2x.png" alt="Reviews-getapp" class=" w-3/4 h-14">
			</div>
			<div>
				<img src=" /img/Reviews_software advice@2x.png" alt="Reviews_software" class=" w-3/4 h-14">
			</div>
			<div class=" col-span-3 ">
				<div class=" grid grid-cols-2 gap-5">
					<div class=" flex justify-end">
						<img src=" /img/6storage-live-chat -review@2x.png" alt="6storage-live-chat-review" class=" w-2/4 h-14">
					</div>
					<div>
						<img src=" /img/Reviews-livechat@2x.png" alt="Reviews-livechat" class=" w-2/4 h-14">
					</div>
				</div>
				
			</div>
			
		</div>
	</div>
	<!-- 6Storage software is here... -->
	<div class=" px-3 py-2 my-2">
		<div class="grid grid-cols-1 pl-8">			
			<div class=" text-left pl-10 font-semibold bg-white bg-opacity-25 border-white border 
			border-opacity-20 rounded-xl backdrop-blur-xl py-3 px-6 shadow-md brightness-150"
			style="box-shadow: 0 8px 32px 0 rgba( 31, 38, 135, 0.37 );
			backdrop-filter: blur( 20px );
			-webkit-backdrop-filter: blur( 20px ); ">
				<h2 class=" text-2xl text-green-700">
					6Storage software – integrated with all your preferred apps to manage all operations
				</h2>
			</div>
		</div>
	</div>

	<div class=" px-3 py-2 my-2 pl-20">
		<div class=" grid grid-cols-5 gap-5 pt-2 pb-4">
			<div class=" col-span-2 bg-white rounded-lg py-4 px-3 flex items-center flex-col shadow-md h-28">
				<img src="/img/Payment Processing Pic.svg" alt="Payment Processing Pic" class=" pb-2 w-2/5">
				<small class=" text-xs font-semibold text-center">Payment Processing</small>
			</div>
			<div class=" col-span-3">
				<div class=" grid grid-cols-3 gap-3">
					<div class=" bg-white rounded-lg py-5 px-2 shadow-md backdrop-blur backdrop-brightness-125 backdrop-filter">
						<img src="/img/6Storage_Logo.svg" alt="6Storage-Logo" class=" w-32 h-full">
					</div>
					<div class=" bg-white rounded-lg py-5 px-2 shadow-md backdrop-blur backdrop-brightness-125 backdrop-filter">
						<img src="/img/Payment Processing Pic.svg" alt="Payment Processing Pic" class=" w-32 h-6">
					</div>
					<div class=" bg-white rounded-lg py-5 px-2 shadow-md backdrop-blur backdrop-brightness-125 backdrop-filter">
						<img src="/img/6Storage_Logo.svg" alt="6Storage-Logo" class=" w-32 h-full">
					</div>
					<div class=" bg-white rounded-lg py-5 px-2 shadow-md backdrop-blur backdrop-brightness-125 backdrop-filter">
						<img src="/img/6Storage_Logo.svg" alt="6Storage-Logo" class=" w-32 h-full">
					</div>
					<div class=" bg-white rounded-lg py-5 px-2 shadow-md backdrop-blur backdrop-brightness-125 backdrop-filter">
						<img src="/img/6Storage_Logo.svg" alt="6Storage-Logo" class=" w-32 h-full">
					</div>
					<div class=" bg-white rounded-lg py-5 px-2 shadow-md backdrop-blur backdrop-brightness-125 backdrop-filter">
						<img src="/img/6Storage_Logo.svg" alt="6Storage-Logo" class=" w-32 h-full">
					</div>
					<div class=" bg-white rounded-lg py-5 px-2 shadow-md backdrop-blur backdrop-brightness-125 backdrop-filter">
						<img src="/img/6Storage_Logo.svg" alt="6Storage-Logo" class=" w-32 h-full">
					</div>
					
				</div>				
			</div>
		</div>
		<div class=" grid grid-cols-5 gap-5 py-4">
			<div class=" col-span-2 bg-white rounded-lg py-4 px-3 flex items-center flex-col shadow-md h-28">
				<img src="/img/Payment Processing Pic.svg" alt="Payment Processing Pic" class=" pb-2 w-2/5">
				<small class=" text-xs font-semibold text-center">Gate Access Controls</small>
			</div>
			<div class=" col-span-3">
				<div class=" grid grid-cols-3 gap-3">
					<div class=" bg-white rounded-lg py-5 px-2 shadow-md backdrop-blur backdrop-brightness-125 backdrop-filter">
						<img src="/img/6Storage_Logo.svg" alt="6Storage-Logo" class=" w-32 h-full">
					</div>
					<div class=" bg-white rounded-lg py-5 px-2 shadow-md backdrop-blur backdrop-brightness-125 backdrop-filter">
						<img src="/img/Payment Processing Pic.svg" alt="Payment Processing Pic" class=" w-32 h-6">
					</div>
					<div class=" bg-white rounded-lg py-5 px-2 shadow-md backdrop-blur backdrop-brightness-125 backdrop-filter">
						<img src="/img/6Storage_Logo.svg" alt="6Storage-Logo" class=" w-32 h-full">
					</div>
					<div class=" bg-white rounded-lg py-5 px-2 shadow-md backdrop-blur backdrop-brightness-125 backdrop-filter">
						<img src="/img/6Storage_Logo.svg" alt="6Storage-Logo" class=" w-32 h-full">
					</div>
					<div class=" bg-white rounded-lg py-5 px-2 shadow-md backdrop-blur backdrop-brightness-125 backdrop-filter">
						<img src="/img/6Storage_Logo.svg" alt="6Storage-Logo" class=" w-32 h-full">
					</div>
					<div class=" bg-white rounded-lg py-5 px-2 shadow-md backdrop-blur backdrop-brightness-125 backdrop-filter">
						<img src="/img/6Storage_Logo.svg" alt="6Storage-Logo" class=" w-32 h-full">
					</div>
										
				</div>				
			</div>
		</div>
		<div class=" grid grid-cols-5 gap-5 py-4">
			<div class=" col-span-2 bg-white rounded-lg py-2 px-3 flex items-center flex-col shadow-md h-28">
				<img src="/img/Payment Processing Pic.svg" alt="Payment Processing Pic" class=" pb-2 w-2/5">
				<small class=" text-xs font-semibold text-center">Operation & Accounting partner</small>
			</div>
			<div class=" col-span-3">
				<div class=" grid grid-cols-3 gap-3">
					<div class=" bg-white rounded-lg py-5 px-2 shadow-md backdrop-blur backdrop-brightness-125 backdrop-filter">
						<img src="/img/6Storage_Logo.svg" alt="6Storage-Logo" class=" w-32 h-full">
					</div>
					<div class=" bg-white rounded-lg py-5 px-2 shadow-md backdrop-blur backdrop-brightness-125 backdrop-filter">
						<img src="/img/Payment Processing Pic.svg" alt="Payment Processing Pic" class=" w-32 h-6">
					</div>
					<div class=" bg-white rounded-lg py-5 px-2 shadow-md backdrop-blur backdrop-brightness-125 backdrop-filter">
						<img src="/img/6Storage_Logo.svg" alt="6Storage-Logo" class=" w-32 h-full">
					</div>
					<div class=" bg-white rounded-lg py-5 px-2 shadow-md backdrop-blur backdrop-brightness-125 backdrop-filter">
						<img src="/img/6Storage_Logo.svg" alt="6Storage-Logo" class=" w-32 h-full">
					</div>
					<div class=" bg-white rounded-lg py-5 px-2 shadow-md backdrop-blur backdrop-brightness-125 backdrop-filter">
						<img src="/img/6Storage_Logo.svg" alt="6Storage-Logo" class=" w-32 h-full">
					</div>
					<div class=" bg-white rounded-lg py-5 px-2 shadow-md backdrop-blur backdrop-brightness-125 backdrop-filter">
						<img src="/img/6Storage_Logo.svg" alt="6Storage-Logo" class=" w-32 h-full">
					</div>
					
					
				</div>				
			</div>
		</div>
		
	</div>

	<!-- Self storage management software is here -->
	<div class=" px-3 py-2 my-2">
		<div class=" grid grid-cols-1 pl-8">
			<div class=" text-left pl-10 font-semibold bg-white bg-opacity-25 border-white border
			border-opacity-20 rounded-xl backdrop-blur-xl py-3 px-6 shadow-md brightness-150"
			style="box-shadow: 0 8px 32px 0 rgpa(31, 38, 135, 0.37);
			backdrop-filder:blur(20px); -webkit-backdrop-filter:blur(20px);">
				<h2 class=" text-2xl text-green-700">
					Self storage management software
				</h2>

			</div>
		</div>
	</div>
	

	<div class="ml-1 py-5 w-auto max-w-full overflow-x-auto whitespace-nowrap h-16 pt-4">
		<!-- svelte-ignore a11y-invalid-attribute -->
		<a href="#" class=" mx-2 py-4 px-14 rounded-full font-bold bg-purple-200 text-black hover:text-white 
		hover:bg-purple-600 focus:bg-purple-600">Feature</a>
		<!-- svelte-ignore a11y-invalid-attribute -->
		<a href="#" class=" mx-2 py-4 px-14 rounded-full font-bold bg-purple-200 text-black hover:text-white 
		hover:bg-purple-600">Feature</a>
		<!-- svelte-ignore a11y-invalid-attribute -->
		<a href="#" class=" mx-2 py-4 px-14 rounded-full font-bold bg-purple-200 text-black hover:text-white 
		hover:bg-purple-600">Feature</a>
		<!-- svelte-ignore a11y-invalid-attribute -->
		<a href="#" class=" mx-2 py-4 px-14 rounded-full font-bold bg-purple-200 text-black hover:text-white 
		hover:bg-purple-600">Feature</a>
		<!-- svelte-ignore a11y-invalid-attribute -->
		<a href="#" class=" mx-2 py-4 px-14 rounded-full font-bold bg-purple-200 text-black hover:text-white 
		hover:bg-purple-600">Feature</a>

		
	</div>
	<div class=" pb-72">

	</div>
</main>

